export class DashboardData {
  activePlans?: number;
  completedPlans?: number;
  wipData?:any[];
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/dashboardData.ts